<script lang="ts">
	//Design system components
	import { Container, Slider, Text } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	//Svelte stores
	import { createEventDispatcher, getContext } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';

	export let disabled = false;

	const nightModeStore: SvelteStore<any> = getContext('nightMode');
	const dispatch = createEventDispatcher();

	let white = $nightModeStore.white;
	const changeWhite = (e) => {
		dispatch('update', { white: `${e.detail.value}` });
	};
	const a11yProps = {
		sliderValueText: $format('current_brightness_value', {
			values: { value: white },
			default: `Current brightness value is ${white}`,
		}),
		ariaLabel: $format('collapse_title_brightness'),
		ariaLabelValue: $format('current_brightness_value', {
			values: { value: white },
			default: `Current brightness value is ${white}`,
		}),
	};
</script>

<Container class="mb-s" padding="0">
	<Text element="h2" class="mb-m">
		{$format('select_type', {
			values: { type: $format('label_white') },
		})}
	</Text>
	<Slider
		id="slider-1i9hckn"
		withOverlay={false}
		stopValueLabel
		{disabled}
		type="horizontal"
		title={capFirstChar($format('collapse_title_brightness'))}
		value={white}
		{a11yProps}
		min={0}
		on:value_change={changeWhite}
	/>
</Container>
